import { DatePickerMonth } from "./data-picker-month";
import { Datepicker } from "./datepicker";
import { Range } from "./range";

export class DatepickerService {
    quarters = ['1st Quarter ’',

        '2nd Quarter ’',

        '3rd Quarter ’',

        '4th Quarter ’'];

    months = ['Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    datepicker: Datepicker = new Datepicker();
    constructor() {

        document.body.addEventListener(
            'click',
            (event: any) => {

                if (event.target.classList.contains('mask')) {
                    $('.datepicker-fon').fadeOut(100);
                    this.UpdateChartVal();
                }
            }, false);

    }
    public getDatepicker(): Datepicker {
        return this.datepicker;
    }
    public updateQuarter(month: number): number {
        let quarter: number = 1;
        if (month <= 3) {
            quarter = 1;
        }
        if (month >= 4 && month <= 6) {
            quarter = 2;
        }
        if (month >= 7 && month <= 9) {
            quarter = 3;
        }
        if (month >= 10) {
            quarter = 4;
        }
        return quarter;
    }
    public updateRange(viewType: string): Array<Range>  {
        let Ranges: Array<Range> = this.DefaultRange();
        for (let i = 0; i < Ranges.length; i++) {
            if (Ranges[i].val === viewType) {
                Ranges[i].class = 'datepicker-data-select';
            }
            else {
                Ranges[i].class = '';
            }
        }
        return Ranges;

    }
    public updateValue(settings: any): string {
        if (settings.viewType === 'daysOfMonth') {

            return `${this.months[Number(settings.month) - 1]} 01, ${settings.year} — ${this.months[Number(settings.month) - 1]} ${32 - new Date(settings.year, Number(settings.month) - 1, 32).getDate()}, ${settings.year}`;
        }
        if (settings.viewType === 'monthsOfYear') {
            return `${settings.year} year`
        }
        if (settings.viewType === 'monthsOfQuarter') {

            return `${this.quarters[settings.quarter - 1]}${String(settings.year).substring(2, 4)}`;
        }

    }

    public DefaultMonth(): any {
        return [new DatePickerMonth('January', 'datepicker-list-line'),
        new DatePickerMonth('February', ''),
        new DatePickerMonth('March', 'datepicker-list-line'),
        new DatePickerMonth('April', ''),
        new DatePickerMonth('May', 'datepicker-list-line'),
        new DatePickerMonth('June', ''),
        new DatePickerMonth('July', 'datepicker-list-line'),
        new DatePickerMonth('August', ''),
        new DatePickerMonth('September', 'datepicker-list-line'),
        new DatePickerMonth('October', ''),
        new DatePickerMonth('November', 'datepicker-list-line'),
        new DatePickerMonth('December', '')
        ]
    }
    public UpdateChartVal() {
        $('.mask').toggle();
        if (window.scrollY >= 110) return;
        let chartLine: HTMLElement = (<HTMLElement>document.querySelector('.chart-val-two'));

        if (chartLine.style.bottom === '220px') {
            chartLine.style.bottom = '219px';

        } else {
            chartLine.style.bottom = '220px';

        }
    }
    public DefaultRange(): Array<Range> {
        return [new Range('Month', 'daysOfMonth', ''),
        new Range('Quarter', 'monthsOfQuarter', ''),
        new Range('Year', 'monthsOfYear', '')
        ]
    }

}


// WEBPACK FOOTER //
// ./src/app/components/class/datepicker/datepicker.service.ts